import debugT from 'debug';
import container from 'modules/section-content';
import domify from 'domify';
import 'bootstrap';
import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import $ from 'jquery';
import page from 'modules/ab-page-js';
import splash from './view/index.pug';
import metadata from './metadata.json';
import ContactForm from 'auth0-contact-form';

import MachineToMachine from './components/MachineToMachine';

const metricsLib = window.metricsLib;

let unmountMachineToMachineApp = () => {};

export default function register() {
  page('/machine-to-machine', initial, snippets);

  page.exit('/machine-to-machine', unMountApp);
}

function initial(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);
  // const props = Object.assign(window.PRESS_DATA || {}, { route: ctx.params.data || 'press' });
  render(<MachineToMachine />, document.getElementById('js-machine-to-machine-app'));

  return next();
}

/**
 * Snippets
 */
function snippets(ctx, next) {
  const $ = window.$;

  contactFormModals();
  next();
}

/**
 *  // Contact Sales Form
 */
function contactFormModals() {
  const salesContactFormOptions = {
    onModalOpen() {
      window.metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      window.metricsLib.track('register:lead:homepage-contact-form', metricsData);
      if (window.mouseFlow) window.mouseFlow.formSubmitSuccess('#contact-form-modal__form');
    },
    onFormFail(metricsData) {
      window.metricsLib.track('fail:register:lead:homepage-contact-form', metricsData);
      if (window.mouseFlow) window.mouseFlow.formSubmitFailure('#contact-form-modal__form');
    },
    source: 'home-page'
  };
  const salesContactForm = new ContactForm(salesContactFormOptions);

  $('.open-contact-form-modal').click(() => salesContactForm.show({ includePhoneField: true }));
}

function unMountApp(ctx, next) {
  unmountComponentAtNode(document.getElementById('js-machine-to-machine-app'));
  return next();
}



// WEBPACK FOOTER //
// ./src/pages/machine-to-machine/client.js